/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';
import * as actionTypes from './AddressBook-ActionTypes';
import initialState from '../../initialState';
import * as actions from '../../../MfeCheckout/ducks/Member/AddressBookEntry/AddressBookEntry-Actions';

const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

const addressBookReducer = (state = initialState.addressBook, action) => {
    switch (action.type) {
        case actionTypes.CLEAR_ADDRESS_BOOK:
            return {
                ...state,
                addressBookEntries: [],
                guestAddressBookEntries: [],
                totalEntries: 0,
                pageNumber: 0,
                totalPages: 0,
            };
        case actionTypes.CLEAR_GUEST_ADDRESS_BOOK:
            return {
                ...state,
                guestAddressBookEntries: [],
            };
        case actionTypes.SAVE_ADDRESS_BOOK:
            return {
                ...state,
                addressBookEntries: action.data?.addressBookEntries,
                totalEntries: action.data?.totalEntries,
                pageNumber: action.data?.pageNumber,
                totalPages: action.data?.totalPages,
            };
        case actionTypes.SAVE_BILLING_ADDRESS:
            return {
                ...state,
                billingAddress: action.data.billingAddress,
            };
        case actionTypes.SAVED_GUEST_ADDRESS_BOOK:
            return {
                ...state,
                guestAddressBookEntries: [...state.guestAddressBookEntries.slice(0, 4), action.data.guestAddressBookEntries],
            };

        case actions.setAddressBookEntry().type:
            if (REACT_APP_INJECTABLE === 'false') {
                return {
                    ...state,
                    addressBookEntries: action.data?.addressBookEntries,
                    totalEntries: action.data?.totalEntries,
                    pageNumber: action.data?.pageNumber,
                    totalPages: action.data?.totalPages,
                };
            }
            return state;
        case actions.clearAddressBookEntry().type:
            if (REACT_APP_INJECTABLE === 'false') {
                return {
                    ...state,
                    addressBookEntries: [],
                    guestAddressBookEntries: [],
                    totalEntries: 0,
                    pageNumber: 0,
                    totalPages: 0,
                };
            }
            return state;
        default:
            return state;
    }
};

export default addressBookReducer;
